"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.function.name");





















































































































var _user = require("@/utils/user"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { tableData: [], // 列表数据
      droplist: [], searchData: { name: '', parentName: '', code: '', isEnable: '', page: 1, // 当前页码
        rows: 10 // 页码条数
      }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, newadd: false, title: '新增', addData: { id: '', parentId: '', name: '', code: '', isEnableisEnable: '' }, defaultData: { id: '', parentId: '', name: '', code: '', isEnable: '' }, rules: { name: [{ required: true, message: '请输入品类名称', trigger: 'blur' }], isEnable: [{ required: true, message: '请选择是否启用', trigger: 'blur' }] } };}, filters: { isEnabledFilter: function isEnabledFilter(val) {if (val == '0') {return '禁用';} else if (val == '1') {return '启用';} else {return val;}} }, mounted: function mounted() {var self = this;self.init();self.getdrop();}, methods: { checkPermission: _user.checkPermission, init: function init() {var self = this;self.getData('/api/category', self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, resetFun: function resetFun() {// 重置
      this.searchData.name = '';this.searchData.code = '';this.searchData.isEnable = '';this.searchData.parentName = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;this.init();}, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;this.init();}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;this.init();}, delMenu: function delMenu(item) {var self = this;self.$confirm('确定删除该记录吗？', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(function () {self.delData('/api/category/' + item.id, {}, function (res) {self.$message({ message: '删除成功!', type: 'success' });self.searchData.page = 1;self.init();});}).catch(function () {});}, addFun: function addFun() {// 新增
      this.title = '新增';this.newimg = '';this.addData = JSON.parse(JSON.stringify(this.defaultData));this.newadd = true;}, closeRefund: function closeRefund(done) {// 重置新增列表
      this.$refs['addForm'].resetFields();done();}, onSubmit: function onSubmit() {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/category', self.addData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },

    updateMenu: function updateMenu(item) {
      this.title = '修改';
      var self = this;
      self.getData('/api/category/' + item.id, self.searchData, function (res) {
        self.addData = {
          id: res.id,
          parentId: res.parentId,
          name: res.name,
          code: res.code,
          isEnable: res.isEnabled };

        if (self.addData.isEnable == '0') {
          self.addData.isEnable = '禁用';
        } else if (self.addData.isEnable == '1') {
          self.addData.isEnable = '启用';
        }
        self.newadd = true;
      });
    },
    onUpdate: function onUpdate(item) {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (self.addData.isEnable == '禁用') {
          self.addData.isEnable = '0';
        } else if (self.addData.isEnable == '启用') {
          self.addData.isEnable = '1';
        }
        if (valid) {
          self.putData('/api/category/' + self.addData.id, self.addData, function (res) {
            self.$message({
              message: '修改成功!',
              type: 'success' });

            self.searchData.page = 1;
            self.init();
            self.onCencal();
          });
        } else {
          return false;
        }
      });
    },
    onCencal: function onCencal() {
      this.newadd = false;
      this.$refs['addForm'].resetFields();
    },
    getdrop: function getdrop() {
      var self = this;
      self.getData('/api/category/parentCode/0', {}, function (res) {
        self.droplist = res;
      });
    } } };exports.default = _default;